export const permissionRoutes = [
    {
        path: '',
        name: 'Permission',
        exact: true,
        component: () => import('../views/PermissionIndex.vue'),
        meta: {
            breadcrumb: [{ label: 'All Permissions' }],
            godOnly: true,
        },
    },
];
